import React from "react";
import { PropTypes } from "prop-types";
import { ProducerPaymentReportCell, ProducersDetailsListLoader } from "common/components/producer";
import { MrbInfiniteScrollGrid } from "mrb/components/infinite-scroll-grid";
import Tabs from "common/components/tabs/Tabs";
import { observer } from "mobx-react";

function ProducerReportTemplate({ producerReportViewStore, t }) {
    const { gridStore, routeStore, setContainerRef, reportViews, setSelectedReportViewId, selectedReportViewId } =
        producerReportViewStore;
    return (
        <div className="order-1">
            <div className="u-mar--bottom--tny">
                <Tabs
                    id="producer-radio-buttons"
                    options={reportViews}
                    value={selectedReportViewId}
                    onChange={(value) => {
                        setSelectedReportViewId(value);
                    }}
                />
            </div>
            <h1 className="u-type--base u-mar--bottom--sml">{t("COMMON.PRODUCER.REPORT.TITLE")}</h1>

            <div className="c-producers__card" ref={setContainerRef}>
                {selectedReportViewId === 0 && <ListenersTableHeader t={t} />}
                {selectedReportViewId === 1 && <ContentTableHeader t={t} />}
                {selectedReportViewId === 2 && <TracksTableHeader t={t} />}
                <div className="c-producers__body">
                    <MrbInfiniteScrollGrid
                        loaderRenderer={() => <ProducersDetailsListLoader />}
                        loadMoreLoader={<ProducersDetailsListLoader row={4} />}
                        emptyStateRenderer={() => <EmptyState t={t} />}
                        classNameOverride=""
                        store={gridStore}
                        t={t}
                        cellRenderer={(props) => (
                            <ProducerPaymentReportCell
                                producerPaymentReportPreviewViewStore={producerReportViewStore}
                                routeStore={routeStore}
                                {...props}
                            />
                        )}
                    />
                </div>
            </div>
        </div>
    );
}

ProducerReportTemplate.propTypes = {
    producerReportViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

function EmptyState({ t }) {
    return (
        <div className="c-card--primary">
            <div className="u-type--center u-padd--top--lrg u-padd--bottom--lrg">
                <i className="u-icon u-icon--welcome u-icon--welcome--sml u-mar--bottom--sml"></i>
                <h5 className="">{t("COMMON.PRODUCER.REPORT.EMPTY_STATE.MESSAGE")}</h5>
            </div>
        </div>
    );
}

function ListenersTableHeader({ t }) {
    return (
        <div className="c-producers__header">
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.USER")}</div>
            <div className="c-producers__item__col">
                {t("COMMON.PRODUCER.REPORT.COLUMNS.SUBSCRIPTION_CYCLE_START_DATE")}
            </div>
            <div className="c-producers__item__col">
                {t("COMMON.PRODUCER.REPORT.COLUMNS.SUBSCRIPTION_CYCLE_END_DATE")}
            </div>
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.PRODUCER_PLAYBACK_TIME")}</div>
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.PRODUCER_PLAYBACK_POINTS")}</div>
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.TOTAL_USER_PLAYBACK_TIME")}</div>
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.PRODUCER_PAYMENT")}</div>
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.SUBSCRIPTION_PLAN")}</div>
        </div>
    );
}

function ContentTableHeader({ t }) {
    return (
        <div className="c-producers__header">
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.ALBUM_TITLE")}</div>
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.PRODUCER_PLAYBACK_TIME")}</div>
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.PRODUCER_PLAYBACK_POINTS")}</div>
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.PRODUCER_PAYMENT")}</div>
        </div>
    );
}

function TracksTableHeader({ t }) {
    return (
        <div className="c-producers__header">
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.TRACK")}</div>
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.ALBUM_TITLE")}</div>
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.TRACK_DURATION")}</div>
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.PRODUCER_PLAYBACK_TIME")}</div>
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.PRODUCER_PLAYBACK_POINTS")}</div>
            <div className="c-producers__item__col">{t("COMMON.PRODUCER.REPORT.COLUMNS.PRODUCER_PAYMENT")}</div>
        </div>
    );
}

export default observer(ProducerReportTemplate);
